/* shopping areas */
export const GET_SHOPPING_AREAS = "GET_SHOPPING_AREAS"
export const GET_SHOPPING_AREAS_SUCCESS = "GET_SHOPPING_AREAS_SUCCESS"
export const API_ERROR = "API_ERROR"
